import { Enum } from "./Enum";

export const E_KEYWORD = Object.freeze({
  MAIN: `/seo-keyword`,
  CREATE_OR_UPDATE: `/seo-keyword/bulk`,
});

export type KEYWORD = Enum<typeof E_KEYWORD>;